import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { usePrivateIntelligence } from "~/components/AssetModalV2/hooks/usePrivateIntelligence";
import { useCollapsibleSectionsContext } from "~/components/AssetModalV2/InfoPanel/CollapsibleSectionsContextProvider";
import { CollapsibleSection } from "~/components/AssetModalV2/InfoPanel/components/CollapsibleSection";
import { EditableInfoPanelDescription } from "~/components/AssetModalV2/InfoPanel/components/EditableInfoPanelDescription";
import { PrivateIntelligenceSection } from "~/components/AssetModalV2/InfoPanel/components/PrivateIntelligenceSection";
import { AssetTagsList } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/AssetTagsList";
import { FileInfo } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/FileInfo";
import { useCurrentClipPermissions } from "~/components/PrivateAssetModal/hooks/useCurrentClipPermissions";
import { centralizedClipDescriptionSelector, centralizedClipTypeSelector } from "~/store/centralizedClip/selectors";
import { canChangeVersionDetails } from "~/utils/permissions/assetPermissions";
export const DESCRIPTION_AND_TAGS_SECTION = "DESCRIPTION_AND_TAGS_SECTION";
export const PrivateDescriptionAndTagsCollapsibleSection = /*#__PURE__*/ memo(()=>{
    const { clipPermissions } = useCurrentClipPermissions();
    const description = useSelector(centralizedClipDescriptionSelector);
    const clipType = useSelector(centralizedClipTypeSelector);
    const { expandedSections, toggleSection } = useCollapsibleSectionsContext();
    const isExpanded = expandedSections["descriptionAndTags"];
    const canEdit = canChangeVersionDetails(clipPermissions);
    // All intelligence logic is now encapsulated in this hook
    const intelligence = usePrivateIntelligence(clipType);
    const onOpenChange = useCallback(()=>{
        toggleSection("descriptionAndTags");
    }, [
        toggleSection
    ]);
    return /*#__PURE__*/ _jsx(CollapsibleSection, {
        title: "Description & Tags",
        isExpanded: isExpanded,
        onOpenChange: onOpenChange,
        "data-testid": DESCRIPTION_AND_TAGS_SECTION,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col [&>*+*]:mt-4",
            children: [
                canEdit ? /*#__PURE__*/ _jsx(EditableInfoPanelDescription, {}) : // Show user description if available (not AI summary)
                description && /*#__PURE__*/ _jsx("div", {
                    className: "text-12 text-grey-11",
                    "data-testid": "INFO_PANEL_DESCRIPTION_TEXT",
                    children: description
                }),
                /*#__PURE__*/ _jsx(AssetTagsList, {
                    permissions: clipPermissions
                }),
                /*#__PURE__*/ _jsx(PrivateIntelligenceSection, {
                    intelligence: intelligence,
                    title: "Summary & Smart Tags",
                    showDisclaimer: true
                }),
                /*#__PURE__*/ _jsx(FileInfo, {})
            ]
        })
    });
});
PrivateDescriptionAndTagsCollapsibleSection.displayName = "PrivateDescriptionAndTagsCollapsibleSection";
